export type CartTabDTO = {
  product_item_id: number;
  catalog_id: number;
  selected_stock_code: string | null;
  quantity: number;
};

export type CartStorageState = {
  orderFlow: string;
  selectedStockCode: string | null;
  selectedExpressTier: string | null;
  cartsByTab: Partial<Record<string, CartTabDTO[]>>;
};

const KEY_PREFIX = "ct_cart_";

export const saveCartToStorage = (cartId: string | number, state: CartStorageState): void => {
  try {
    localStorage.setItem(`${KEY_PREFIX}${cartId}`, JSON.stringify(state));
  } catch {
    // Quota exceeded or storage unavailable — the cart just won't survive the refresh.
  }
};

export const loadCartFromStorage = (cartId: string | number): CartStorageState | null => {
  try {
    const raw = localStorage.getItem(`${KEY_PREFIX}${cartId}`);
    return raw ? (JSON.parse(raw) as CartStorageState) : null;
  } catch {
    return null;
  }
};

export const clearCartFromStorage = (cartId: string | number): void => {
  try {
    localStorage.removeItem(`${KEY_PREFIX}${cartId}`);
  } catch {
    // ignore
  }
};
